// extracted by mini-css-extract-plugin
export default {"imageWrapper":"wP-z","hovered":"xP-z","hoverImage":"yP-z","mainImage":"zP-z","imageNoBackground":"AP-z","fullSizeImage":"BP-z"};